// @ts-nocheck
import component from "../../legacy/unavailable-noop"

export default component
